<template>
  <div class="min-h-screen bg-slate-50">
    <header class="bg-gradient-to-r from-slate-800 to-slate-900 text-white py-16">
      <div class="container mx-auto px-4 text-center">
        <!-- Logo/Brand element -->
        <div class="flex justify-center mb-6">
          <router-link to="/" class="transition-transform duration-200 hover:scale-105">
            <img src="@/assets/images/logo-compact.svg" alt="Hardware Pulse" class="h-8 w-auto opacity-80 hover:opacity-100 transition-opacity duration-200" />
          </router-link>
        </div>
        <h1 class="heading-xl">Privacy Policy</h1>
        <p class="text-slate-300 mt-4">How we protect and handle your information</p>
      </div>
    </header>

    <main class="container mx-auto px-4 py-12 max-w-4xl">
      <div class="bg-white rounded-xl shadow-lg p-8 lg:p-12 border border-slate-200">
        <div
          class="prose prose-slate max-w-none prose-headings:text-slate-900 prose-headings:font-bold prose-h2:text-2xl prose-h2:mt-8 prose-h2:mb-4 prose-p:text-slate-700 prose-p:leading-relaxed prose-a:text-blue-600 prose-a:no-underline hover:prose-a:underline prose-ul:text-slate-700"
        >
          <section>
            <h2>Introduction</h2>
            <p>
              Welcome to Hardware Pulse. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website,
              subscribe to our newsletter, and interact with our content, including our affiliate links and on-screen ads.
            </p>
          </section>

          <section>
            <h2>Information We Collect</h2>
            <p>
              We may collect the following types of information:
            </p>
            <ul>
              <li><strong>Personal Data:</strong> Email addresses and contact details when you subscribe to our newsletter.</li>
              <li>
                <strong>Usage Data:</strong> Information automatically collected through cookies, log files, and similar technologies (e.g., IP address, browser
                type, pages visited).
              </li>
              <li><strong>Affiliate & Advertising Data:</strong> Information related to your interactions with affiliate links and on-screen ads.</li>
            </ul>
          </section>

          <section>
            <h2>How We Use Your Information</h2>
            <p>
              We use the collected information to:
            </p>
            <ul>
              <li>Provide, maintain, and improve our website and services.</li>
              <li>Send you newsletters, updates, and promotional communications.</li>
              <li>Analyze usage trends to better understand our audience and optimize our content.</li>
              <li>Comply with legal obligations and protect our rights.</li>
            </ul>
          </section>

          <section>
            <h2>Affiliate Links and Advertisements</h2>
            <p>
              Some of the links on our website are affiliate links, and we may receive a commission if you make a purchase through them. On-screen
              advertisements are provided by third-party advertisers. We do not store or track your personal data through these affiliates or ads.
            </p>
          </section>

          <section>
            <h2>Third-Party Services</h2>
            <p>
              We may share your information with trusted third-party service providers who help us operate our website, conduct our business, or provide
              services to you. These third parties are required to keep your information confidential and use it only for the purposes for which we disclose it
              to them.
            </p>
          </section>

          <section>
            <h2>Data Security</h2>
            <p>
              We take reasonable measures to protect your personal information from unauthorized access, disclosure, alteration, or destruction. However, no
              security system is impenetrable, and we cannot guarantee the security of our systems 100%.
            </p>
          </section>

          <section>
            <h2>Your Rights and Choices</h2>
            <p>
              Depending on your location, you may have certain rights regarding the personal information we collect. These may include the right to access,
              correct, or delete your personal data. If you have any questions or requests regarding your personal information, please contact us using the
              details below.
            </p>
          </section>

          <section>
            <h2>Changes to This Privacy Policy</h2>
            <p>
              We reserve the right to modify this Privacy Policy at any time. Any changes will be posted on this page, and the updated policy will be effective
              immediately upon posting. Your continued use of our website constitutes your acceptance of the updated Privacy Policy.
            </p>
          </section>

          <section>
            <h2>Contact Information</h2>
            <p>
              If you have any questions or concerns about this Privacy Policy, please contact us at
              <a href="mailto:support@hardwarepulse.com">support@hardwarepulse.com</a>.
            </p>
          </section>
        </div>
      </div>
    </main>

    <footer class="bg-slate-800 text-slate-300 py-8">
      <div class="container mx-auto px-4 text-center">
        <p>&copy; 2025 Hardware Pulse. All Rights Reserved.</p>
      </div>
    </footer>
  </div>
</template>

<script>
  export default {
    name: 'PrivacyPolicy',
  };
</script>

<style scoped>
  /* Tailwind CSS handles all styling with @tailwindcss/typography for prose content */
</style>
